import Routes from './routes'
import 'windi.css'
import '../../assets/css/index.scss'

export default {
  // name version 必须为字面常量
  name: 'portal-homepage-nanhai',
  title: '门户首页',
  version: '0.1.11',
  description: '门户首页',
  routes: Routes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
